import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import {Upload} from './upload';

@Injectable()
export class UploadService {
upload : Upload;
  constructor(private af: AngularFireAuth) { }
  private basePath:string = '/uploads';
  private path:string = '/documents';
  pushUpload(upload: Upload,subPath: String,fileName: String) : Upload {
   
    let storageRef = firebase.storage().ref();
    let uploadTask = storageRef.child(`${this.basePath}/${subPath}/${fileName}`).put(upload.file);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        upload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
      },
      (error) => {
        // upload failed
        //console.log(error)
      },
      () => {
        // upload success
        upload.url = uploadTask.snapshot.downloadURL;
        upload.name = upload.file.name;
        this.saveFileData(upload);
      
        this.upload = upload;

        //console.log("uploaded "+this.upload.url);
      }
    );
    //console.log("upload success "+url);

      return upload;

    
  }
  // Writes the file details to the realtime db
 private saveFileData(upload: Upload) {
    //this.db.list(`${this.basePath}/`).push(upload);
    //console.log(""+upload.url);
  }
uploadFile(upload: Upload,subPath: String,fileName: String) : any {
   
    let storageRef = firebase.storage().ref();
    let uploadTask = storageRef.child(`${this.basePath}/${this.path}/${subPath}/${fileName}`).put(upload.file);
    return uploadTask;
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/uploads/shared/upload.service.ts